module.exports = __webpack_public_path__ + "img/ic-arrow-s.fccfc6f6.svg";